import { render } from "./IntegrationCollectionCard.vue?vue&type=template&id=440b2f68&scoped=true"
import script from "./IntegrationCollectionCard.vue?vue&type=script&lang=ts"
export * from "./IntegrationCollectionCard.vue?vue&type=script&lang=ts"

import "./IntegrationCollectionCard.vue?vue&type=style&index=0&id=440b2f68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-440b2f68"

export default script